import SectionHeader from "@components/SectionHeader";
import notFoundIcon from "./img/confirm-icon.svg";
import Button from "@components/Button";
import SideBySideLayout from "@components/SideBySideLayout";
import BGMobile from "./img/header-mobile.jpg";
import BGDesktop from "./img/ic-logout-view.jpg";
import "./style.scss";

export default function LogoutView() {
  const dgUrl = `${
    import.meta.env.VITE_DG_URL
  }/customer/account/loginwithredirect?referer=${btoa(
    import.meta.env.VITE_DG_URL + "/inspiration_club"
  )}`;
  const vuseUrl = `${
    import.meta.env.VITE_VUSE_URL
  }/customer/account/loginwithredirect?referer=${btoa(
    import.meta.env.VITE_VUSE_URL + "/inspiration_club/"
  )}`;

  return (
    <SideBySideLayout bgImageDesktop={BGDesktop} bgImageMobile={BGMobile}>
      <div className="logout-view-content">
        <div className="hero-container">
          <div className="hero-wrapper">
            <div className="info-text">
              <SectionHeader>
                <strong>Komm bald</strong> wieder vorbei
              </SectionHeader>
            </div>
          </div>
        </div>
        <div className="main-content">
          <img className="info-icon" src={notFoundIcon} alt="info-icon" />
          <p className="header">Erfolgreich abgemeldet</p>
          <p className="sub-header">
            Wir werden auf dich mit neuen Aktivitäten und <br /> Angeboten
            warten.
            <br />
            <strong>Es sei denn, du willst sofort zurückkehren?</strong>
          </p>
          <div className="buttons-wrapper">
            <p>Anmeldung durch:</p>
            <Button target="_self" btnClass="yellow" href={dgUrl}>
              myglo.com
            </Button>
            <Button target="_self" btnClass="yellow" href={vuseUrl}>
              vuse.com
            </Button>
          </div>
        </div>
      </div>
    </SideBySideLayout>
  );
}
